import Context from '../../provider';
import React, { useContext, useEffect, useState } from 'react';

export default function RootVars() {
  const { init, lang, colorScheme } = useContext(Context);
  const [color, setColor] = useState(null);

  useEffect( () => {
    if (init) {
      setColor(colorScheme);
    }
  }, [init, colorScheme]);

  return (
    <style id='root-theme'>
    {`:root {
      --body-background-color: ${color?.bodyBg};
      --body-text-color: ${color?.bodyText};
      --primary-color: ${color?.primary};
      --primary-contrast-color: ${color?.primaryContrast};
      --secondary-color: ${color?.secondary};
      --secondary-contrast-color: ${color?.secondaryContrast};
      --success-color: ${color?.success};
      --success-contrast-color: ${color?.successContrast};
      --danger-color: ${color?.danger};
      --danger-contrast-color: ${color?.dangerContrast};
      --warning-color: ${color?.warning};
      --warning-contrast-color: ${color?.warningContrast};
      --info-color: ${color?.info};
      --info-contrast-color: ${color?.infoContrast};
      --light-color: ${color?.light};
      --light-contrast-color: ${color?.lightContrast};
      --dark-color: ${color?.dark};
      --dark-contrast-color: ${color?.darkContrast};
      --disable-color: ${color?.disable};
      --backdrop-color: ${color?.backdrop};
      --overlay-color: ${color?.overlay};
      --white-color: ${color?.white};
      --black-color: ${color?.black};
      --grey-color: ${color?.grey};
      --dark-grey-color: ${color?.darkGrey};
      --transparent-color: ${color?.transparent};

      --title-font-family: ${lang === 'en' ? 'Poppins' : 'Noto Sans TC'};;
      --text-font-family: ${lang === 'en' ? 'Lato' : 'Noto Sans TC'};
    }`}
    </style>
  );
}